import React, { useEffect } from 'react'
import MenuItem from './MenuItem'
import { useAppDispatch, useAppSelector } from '../../../hooks/redux'
import { useNavigate } from 'react-router-dom'
import { logout } from '../../../store/slices/authSlice'
import { swalSureLogout } from '../../../functions/swalOptions'
import _ from 'lodash'
import { nanoid } from 'nanoid'
import Icon from '../../../app/icon/Icon'
import { type IconName } from '../../../app/icon/iconsConfig'
import { clearDeviceToken } from '../../../store/actionsCreators/authActions'
import { removeNotifyByDeviceToken } from '../../../functions/shared/notify-helpers/removeNotify'
import { store, type RootState } from '../../../store/store'
import getUserType from '../../../functions/shared/user/getUserType'
import { getAdminRole } from '../../../config/adminRoles'

export default function LandlordMenuPage(): JSX.Element {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const currentUser = useAppSelector((state: RootState) => state.user.currentUser as { email?: string })
    const role = getAdminRole(currentUser)

    useEffect(() => {
        document.getElementById('menu_page')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'

        })
    }, [])

    const logoutHandler = (): any => {
        void swalSureLogout().then(async (result: any) => {
            if (result.isDenied === true) {
                //  const clearDevice = await dispatch(clearDeviceToken())
                //  if (clearDevice.success === true && clearDevice.response != null) {
                dispatch(logout())
                void removeNotifyByDeviceToken({
                    userID: store.getState().user.currentUser.id as number,
                    deviceToken: store.getState().user.currentUser.DeviceToken as string,
                    badges: 0
                })
                location.reload()
                navigate('/auth/login')
                //  }
            }
        })
    }

    const brokerageMenu = [
        {
            label: 'Profile', description: 'Profile, dashboard, BSO credit balance', route: '/landlord/profile/me', bgColor: 'primary', icon: 'person'
        },
        { label: 'Settings', route: '/landlord/settings', description: 'Contact details, order history, notifications', bgColor: 'warning', icon: 'settings' },
        { label: 'Events / Notices', route: '/landlord/events_safe', description: 'Add new notify, warm up your activity', bgColor: 'danger', icon: 'mode_fan' as IconName },
        { label: 'Landlords / Orders', route: '/landlord/landlord_service_orders', description: 'Add new notify, warm up your activity', bgColor: 'danger', icon: 'mode_fan' as IconName },
        { label: 'Key viewings archive', route: '/landlord/key-viewings', description: 'Review key collection and return records', bgColor: 'primary', icon: 'key' as IconName },
        { label: 'Broker analytics', route: '/landlord/broker-analytics', description: 'Profiles, subscriptions and broker engagement', bgColor: 'info', icon: 'chart_simple' as IconName },
    ]
    const marketingMenu = [
        { label: 'Sponsored Partners', route: '/landlord/sponsored_partners', description: 'Manage sponsored partner placements', bgColor: 'primary', icon: 'add_ad' as IconName },
        { label: 'BSO Insider', route: '/landlord/insider', description: 'Create and publish official channel updates', bgColor: 'primary', icon: 'campaign' as IconName },
    ]
    const administrationMenu = [{ label: 'Key viewings archive', route: '/landlord/key-viewings', description: 'Review key collection and return records', bgColor: 'primary', icon: 'key' as IconName }]
    const menuConfig: Array<Array<{
        label: string
        description: string
        route: string
        bgColor: string
        icon: string
        onClick?: any
    }>> = [
        role === 'marketing' ? marketingMenu : role === 'administration' ? administrationMenu : brokerageMenu,

        [
            {
                label: 'Logout',
                route: '#',
                onClick: logoutHandler,
                description: '',
                bgColor: 'warning',
                icon: 'door_open'
            }
        ]
    ].filter(Boolean)

    return (
        <>
            <div
                className="page d-flex flex-column flex-row-fluid fs-5 pt-8 " id='menu_page' style={{ height: '100vh' }}
            >
                <div
                    className="content d-flex flex-column flex-fill p-0 m-4"

                >
                    <div className="w-100 mw-450px mx-auto " >
                        {
                            _.map(menuConfig, (cardConfig) => (
                                <div className="card shadow-sm mb-4 mt-8" key={nanoid()} >
                                    <div className="card-body p-4">
                                        {
                                            _.map(cardConfig, (item) => (
                                                <MenuItem
                                                    {
                                                    ...item
                                                    }
                                                    key={nanoid()}
                                                    icon={<Icon name={item.icon as IconName} className={'fs-3x mx-auto text-white'} />}
                                                />
                                            ))
                                        }
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
                {/* <div className="m-0" style={{ height: '195px' }}></div> */}
            </div>
        </>
    )
}
